export const MAX_CONTRACTS_PER_UPLOAD: number = 5
export const ACCEPT_CONTRACT_MIME_TYPE: string = 'application/pdf'
